import React from 'react';
import CreateNewFolder from '@mui/icons-material/CreateNewFolder';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { AddBox } from '@mui/icons-material';

import {
  PLACE_ORDER_INITIAL_URL,
  PLACE_PATHOLOGY_CONSULTATION_ORDER_FORM,
  TEAM_OVERVIEW_URL,
} from 'constants/urls';
import { ShowPathologistUserOnly } from 'components/ConditionalWrappers/ShowPathologistUserOnly';
import { SidebarListItem } from 'components/Layout/Sidebar/SidebarListItem';
import { SidebarList } from 'components/Layout/Sidebar/SidebarList';

export const NewOrderList = () => (
  <SidebarList>
    <SidebarListItem
      Icon={CreateNewFolder}
      name="New Order"
      path={PLACE_ORDER_INITIAL_URL}
    />
    <ShowPathologistUserOnly>
      <SidebarListItem
        Icon={AddBox}
        name="New Consultation"
        path={PLACE_PATHOLOGY_CONSULTATION_ORDER_FORM}
      />
    </ShowPathologistUserOnly>
    <SidebarListItem
      Icon={AccountCircleIcon}
      name="Team Overview"
      path={TEAM_OVERVIEW_URL}
    />
  </SidebarList>
);
